<template>
  <div v-if="!newDesign">
    <div class="fx fx-start align-center title table_title">
      <span v-html="formatTitle(title)"></span>
      <div class="ml-20">
        <vue-spinner :color="wrapperLoadColor" v-if="showLoader"></vue-spinner>
      </div>
    </div>
    <v-notification v-if="this.showAlertMessage">
    </v-notification>
    <!-- Buttons -->
    <div v-if="showFiltersWithBtn" class="topping fx">
      <div class="topping__panel fx align-center">
        <div class="topping__btns fx">
          <button v-if="!sendFilterRequestAfterSelect" class="btn-t btn--borderColor flex-center" @click="updateByFiltersWithPause">{{ acceptFiltersButtonLabel }}
          </button>
          <button v-if="isListFiltered && showResetFilterButton" class="btn-t btn--borderColor flex-center" @click="resetObject(filters); resetSelectingFilters();">{{ resetFiltersButtonLabel }}
            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M0.976746 20C0.783574 20 0.59473 19.9428 0.434101 19.8355C0.273473 19.7282 0.148276 19.5756 0.0743471 19.3972C0.000418327 19.2187 -0.0189212 19.0223 0.0187748 18.8329C0.0564708 18.6434 0.149509 18.4694 0.28612 18.3328L18.333 0.285944C18.5162 0.102779 18.7646 -0.00012207 19.0236 -0.00012207C19.2827 -0.00012207 19.5311 0.102779 19.7143 0.285944C19.8974 0.469109 20.0003 0.717535 20.0003 0.976569C20.0003 1.2356 19.8974 1.48403 19.7143 1.66719L1.66737 19.7141C1.57676 19.8049 1.46911 19.8769 1.35059 19.9259C1.23207 19.975 1.10502 20.0002 0.976746 20Z"/>
              <path
                  d="M19.0236 20C18.8953 20.0002 18.7682 19.975 18.6497 19.9259C18.5312 19.8769 18.4235 19.8049 18.3329 19.7141L0.286066 1.66719C0.102901 1.48403 0 1.2356 0 0.976569C0 0.717535 0.102901 0.469109 0.286066 0.285944C0.469231 0.102779 0.717657 -0.00012207 0.976691 -0.00012207C1.23573 -0.00012207 1.48415 0.102779 1.66732 0.285944L19.7142 18.3328C19.8508 18.4694 19.9438 18.6434 19.9815 18.8329C20.0192 19.0223 19.9999 19.2187 19.926 19.3972C19.852 19.5756 19.7268 19.7282 19.5662 19.8355C19.4056 19.9428 19.2167 20 19.0236 20Z"/>
            </svg>
          </button>
          <template v-if="showCollapseFilter">
            <button class="btn-t btn--borderColor flex-center" v-if="showFilters === true" @click="showFilters = false">
              {{ minimizeFiltersButtonLabel }}
              <svg viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.24181 5.60334V0.967742C4.24181 0.433468 3.80866 0 3.27407 0C2.73948 0 2.30633 0.433468 2.30633 0.967742V5.60338C1.25439 5.9979 0.5 7.00558 0.5 8.19367C0.5 9.38177 1.25439 10.3894 2.30633 10.7839V19.0323C2.30633 19.5665 2.73948 20 3.27407 20C3.80866 20 4.24181 19.5665 4.24181 19.0323V10.784C5.29386 10.3894 6.04845 9.38181 6.04845 8.19367C6.04845 7.00554 5.29386 5.99787 4.24181 5.60334Z"/>
                <path
                    d="M11.4674 9.81835V0.967742C11.4674 0.433468 11.0342 0 10.4997 0C9.96506 0 9.53191 0.433468 9.53191 0.967742V9.81835C8.47998 10.2129 7.72559 11.2205 7.72559 12.4086C7.72559 13.5967 8.47998 14.6044 9.53191 14.9989V19.0323C9.53191 19.5665 9.96506 20 10.4997 20C11.0342 20 11.4674 19.5665 11.4674 19.0323V14.9989C12.5194 14.6045 13.2737 13.5968 13.2737 12.4086C13.2737 11.2205 12.5194 10.2128 11.4674 9.81835Z"/>
                <path
                    d="M18.6938 5.60338V0.967742C18.6938 0.433468 18.2606 0 17.726 0C17.1915 0 16.7583 0.433468 16.7583 0.967742V5.60334C15.7063 5.99787 14.9517 7.00554 14.9517 8.19367C14.9517 9.38181 15.7063 10.3894 16.7583 10.784V19.0323C16.7583 19.5665 17.1915 20 17.726 20C18.2606 20 18.6938 19.5665 18.6938 19.0323V10.784C19.7458 10.3895 20.5001 9.38181 20.5001 8.19367C20.5001 7.00554 19.7458 5.99787 18.6938 5.60338Z"/>
              </svg>
            </button>
            <button class="btn-t btn--borderColor flex-center" v-else @click="showFilters = true">{{ showFiltersButtonLabel }}
              <svg viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.24181 5.60334V0.967742C4.24181 0.433468 3.80866 0 3.27407 0C2.73948 0 2.30633 0.433468 2.30633 0.967742V5.60338C1.25439 5.9979 0.5 7.00558 0.5 8.19367C0.5 9.38177 1.25439 10.3894 2.30633 10.7839V19.0323C2.30633 19.5665 2.73948 20 3.27407 20C3.80866 20 4.24181 19.5665 4.24181 19.0323V10.784C5.29386 10.3894 6.04845 9.38181 6.04845 8.19367C6.04845 7.00554 5.29386 5.99787 4.24181 5.60334Z"/>
                <path
                    d="M11.4674 9.81835V0.967742C11.4674 0.433468 11.0342 0 10.4997 0C9.96506 0 9.53191 0.433468 9.53191 0.967742V9.81835C8.47998 10.2129 7.72559 11.2205 7.72559 12.4086C7.72559 13.5967 8.47998 14.6044 9.53191 14.9989V19.0323C9.53191 19.5665 9.96506 20 10.4997 20C11.0342 20 11.4674 19.5665 11.4674 19.0323V14.9989C12.5194 14.6045 13.2737 13.5968 13.2737 12.4086C13.2737 11.2205 12.5194 10.2128 11.4674 9.81835Z"/>
                <path
                    d="M18.6938 5.60338V0.967742C18.6938 0.433468 18.2606 0 17.726 0C17.1915 0 16.7583 0.433468 16.7583 0.967742V5.60334C15.7063 5.99787 14.9517 7.00554 14.9517 8.19367C14.9517 9.38181 15.7063 10.3894 16.7583 10.784V19.0323C16.7583 19.5665 17.1915 20 17.726 20C18.2606 20 18.6938 19.5665 18.6938 19.0323V10.784C19.7458 10.3895 20.5001 9.38181 20.5001 8.19367C20.5001 7.00554 19.7458 5.99787 18.6938 5.60338Z"/>
              </svg>
            </button>
          </template>
          <button v-if="showSaveCsvBtn" class="btn-t btn--borderColor flex-center" @click="saveCsv">{{ downloadCsvText }}</button>
        </div>
      </div>
    </div>
    <!-- Filters -->
    <div class="form filter" v-bind:class="getClass" v-if="Object.keys(enabledFilters)?.length > 0">
      <div class="row fx fx-wrap">
        <!-- Col -->
        <div class="col-12 col-md-6 col-lg-4"
             v-for="(column, index) in enabledFilters"
             :key="index">
          <div v-for="(filterObject, filterName) in column" :key="filterName">
            <div v-if="filterName === 'date'" class="filter__group">
              <label class="form__field form__field-date">
                <input type="text"
                       ref="inputFrom"
                       :placeholder="filterObject?.dateFromText ?? 'Дата (от)'"
                       onfocus="(this.type='datetime-local')"
                       onblur="(this.type='text')"
                       v-model="filters[filterObject.dateKey[0]]"
                />
              </label>
              <label class="form__field form__field-date">
                <input type="text"
                       ref="inputTo"
                       :placeholder="filterObject?.dateToText ?? 'Дата (до)'"
                       onfocus="(this.type='datetime-local')"
                       onblur="(this.type='text')"
                       v-model="filters[filterObject.dateKey[1]]"
                />
              </label>
            </div>
            <div v-else-if="filterName === 'dateWithOutTime'" class="filter__group">
              <label class="form__field form__field-date">
                <input type="text"
                       ref="inputFrom"
                       data-type="date"
                       :placeholder="filterObject?.dateFromText ?? 'Дата (от)'"
                       onfocus="(this.type='date')"
                       onblur="(this.type='text')"
                       v-model="filters[filterObject.dateKey[0]]"
                />
              </label>
              <label class="form__field form__field-date">
                <input type="text"
                       ref="inputTo"
                       data-type="date"
                       :placeholder="filterObject?.dateToText ?? 'Дата (до)'"
                       onfocus="(this.type='date')"
                       onblur="(this.type='text')"
                       v-model="filters[filterObject.dateKey[1]]"
                />
              </label>
            </div>
            <instance-input-select v-else
                                   :object="filterObject"
                                   ref="childInstanceSelect"
                                   :index="filterName"
                                   @add-filter-id-arr-single="addFilterId"
                                   @add-filter-data-single="addFilterSingle"
                                   @add-filter-ids-arr="addFilterIdsArray"
                                   @remove-filter-id="removeFilterId"
                                   @remove-filter-ids-arr="removeFilterIdsArray"
            ></instance-input-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="new-design-wrapper" v-else>
    <div class="activation-history-partner__head">
      <div class="--main" style="justify-content: space-between">
        <div class="--filter" :class="showFilters ? 'open' : ''">
          <div class="--open-filter" v-if="showFilters">
            <div class="pah-open-filter button primary" @click="showFilters = false">{{ getLocalization('Hide') }}</div>
            <div class="button primary outline" v-if="isListFiltered && showResetFilterButton" @click="resetObject(filters); resetSelectingFilters();">{{ getLocalization('reset filters') }}</div>
          </div>
          <div class="--close-filter" v-if="!showFilters" @click="showFilters = true">
            <div class="pah-open-filter button orange">{{ getLocalization('Show') }}</div>
          </div>
        </div>
        <div class="--info">
          {{ infoText }}
        </div>
        <div class="d-flex flex-wrap">
          <vue-spinner class="d-flex align-items-center" color="#23a065" v-if="showLoader"></vue-spinner>
          <div v-if="!sendFilterRequestAfterSelect" @click="updateByFiltersWithPause" class="button primary --export filter-btn-mobile">{{ getLocalization('Filter') }}</div>
          <div class="button primary --export" v-if="showSaveCsvBtn" @click="saveCsv" style="margin-left: 15px">
            {{ getLocalization('Download CSV') }}
          </div>
        </div>

      </div>
      <div id="filter-content" class="--other collapse" :class="showFilters ? 'show' : ''">
        <div>
          <div :class="filterObject.className" v-for="(filterObject, filterName) in enabledFilters[1]" :key="filterName">
            <div class="d-flex flex-wrap" v-if="filterName === 'date'">
              <div class="--6-12">
                <div class="label-wrapper" v-if="filterObject?.circle">
                  <div class="--label">{{ filterObject?.dateFromText ?? 'Дата активации' }}</div>
                  <div  class="circle" @mouseover="showHint" @mouseleave="hideHint" @click="toggleHint">
                    <img src="/img/svg/advantages/question.svg" alt="?">
                    <div v-if="isHintVisible" class="hint">{{ hintText }}</div>
                  </div>
                </div>
                <div v-else class="--label">{{ filterObject?.dateFromText ?? 'Дата активации' }}</div>
                <div class="datepicker">
                  <date-picker
                      v-model="filters.dateFrom"
                      valueType="format"
                      type="datetime"
                      format="YYYY-MM-DD HH:mm"
                      input-class="mx-input"
                      :input-attr="{ maxlength: 16}"
                      :placeholder="filterObject?.dateFromText ?? 'Дата (от)'"
                  >
                    <template #input='{ props, events }'>
                      <input
                          v-bind='props'
                          v-on='{
                            ...events,
                            input: event => handleInput(event, events.input),
                          }'>
                    </template>
                  </date-picker>
                </div>
              </div>
              <div class="--6-12 margin-date">
                <div class="--label">{{ filterObject?.dateToText ?? 'Дата активации' }}</div>
                <div class="datepicker">
                  <date-picker
                      v-model="filters.dateTo"
                      valueType="format"
                      type="datetime"
                      format="YYYY-MM-DD HH:mm"
                      input-class="mx-input"
                      :placeholder="filterObject?.dateToText ?? 'Дата (до)'"
                      :input-attr="{ maxlength: 16}"
                  >
                    <template #input='{ props, events }'>
                      <input
                          v-bind='props'
                          v-on='{
                            ...events,
                            input: event => handleInput(event, events.input)
                          }'>
                    </template>
                  </date-picker>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="--label">{{ filterObject['placeholder'] }}</div>
              <instance-input-select
                  :object="filterObject"
                  ref="childInstanceSelect"
                  :index="filterName"
                  @add-filter-id-arr-single="addFilterId"
                  @add-filter-data-single="addFilterSingle"
                  @add-filter-ids-arr="addFilterIdsArray"
                  @remove-filter-id="removeFilterId"
                  @remove-filter-ids-arr="removeFilterIdsArray"
              ></instance-input-select>
            </div>
          </div>
          <div class="button primary --export" v-if="showSaveCsvBtn" @click="saveCsv">
            {{ getLocalization('Download CSV') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseAdminMixin from "../../admin/components/mixins/BaseAdminMixin.vue";
import Multiselect from "vue-multiselect";
import InstanceInputSelect from "./instanceInputSelect.vue";
import AddRemoveSelectedMixin from '../mixins/AddRemoveSelectedMixin'
import AdditionalFunctions from "../mixins/AdditionalFunctions";
import DatePicker from "vue2-datepicker";

export default {
  name: "wrapperFiltersComponent",
  mixins: [
    BaseAdminMixin,
    AddRemoveSelectedMixin,
    AdditionalFunctions
  ],
  components: {
    Multiselect,
    InstanceInputSelect,
    DatePicker
  },
  props: {
    filtersUrl: {
      type: String,
      required: true
    },
    filtersUrlMethod: {
      type: String,
      default: 'get'
    },
    startWithRequest: {
      type: Boolean,
      default: false
    },
    setEnabledFilters: {},
    enableSaveCsv: {
      type: Boolean,
      default: false
    },
    saveCsvUrl: {
      type: String
    },
    title: {
      type: String,
      required: true
    },
    sendFilterRequestAfterSelect: {type: Boolean},
    acceptFiltersButtonLabel: {
      type: String,
      default: 'Применить фильтр'
    },
    minimizeFiltersButtonLabel: {
      type: String,
      default: 'Свернуть'
    },
    showFiltersButtonLabel: {
      type: String,
      default: 'Развернуть'
    },
    resetFiltersButtonLabel: {
      type: String,
      default: 'Сбросить'
    },
    showCollapseFilter: {
      type: Boolean,
      default: true
    },
    showResetFilterButton: {
      type: Boolean,
      default: true
    },
    wrapperLoadColor: {
      type: String,
      default: '#209E73'
    },
    showAlertMessage: {
      type: Boolean,
      default: true
    },
    csvFilename: {},
    downloadCsvText: {
      type: String,
      default: 'Download CSV'
    },
    alwaysShowCsvBtn: {
      type: Boolean,
      default: false
    },
    newDesign: {
      type: Boolean,
      default: false
    },
    infoText: {
      type: String,
      default: ''
    },
    perPage: {
      default: null
    }

  },
  async mounted() {
    this.checkDefaultTime();
    this.hostNameOrigin = window.location.origin;
    this.registerListeners();
    if (this.startWithRequest) {
      await this.updateByFiltersWithPause();
    }
  },

  data() {
    return {
      filters: {
        dateFrom: null,
        dateTo: null,
      },
      showFilters: true,
      hostNameOrigin: null,
      dataDownload: null,
      isHintVisible: false,
      hintText: this.getLocalization('Time is displayed in UTC+3')
    }
  },
  methods: {
    addFilterId(name, id) {
      this.createIfNotExistValueInFiltersByName(name);
      if (Array.isArray(this.filters[name])) {
        this.filters[name].push(id)
      }
      this.checkForSendRequestAfterSelectItemFilter();
    },
    formatTitle(title) {
      const parts = title.split('<p>');
      return parts.map((part, index) => {
        if (index === 0) {
          return `<h2>${part}</h2>`;
        } else {
          return `<p>${part}</p>`;
        }
      }).join('');
    },
    addFilterSingle(name, value) {
      this.createIfNotExistValueInFiltersByName(name, null);
      this.filters[name] = value;
      this.checkForSendRequestAfterSelectItemFilter();
    },
    addFilterIdsArray(name, ids) {
      this.createIfNotExistValueInFiltersByName(name);
      if (Array.isArray(this.filters[name])) {
        ids.forEach(el => this.filters[name].push(el['id']));
      }
      this.checkForSendRequestAfterSelectItemFilter();
    },
    createIfNotExistValueInFiltersByName(name, value = []) {
      if (this.filters[name] === undefined) {
        this.$set(this.filters, name, value)
      }
    },
    removeFilterId(name, id) {
      if (Array.isArray(this.filters[name])) {
        this.filters[name] = this.filters[name].filter(el => el !== id)
      } else if (this.filters[name]) {
        this.filters[name] = null;
      }
      this.checkForSendRequestAfterSelectItemFilter();
    },
    removeFilterIdsArray(name) {
      if (Array.isArray(this.filters[name])) {
        this.filters[name] = [];
      }
      this.checkForSendRequestAfterSelectItemFilter();
    },

    async updateByFiltersWithPause() {
      this.timeout = setTimeout(
          () => this.doWithStopRequest(() => this.doWithLoader(() => this.updateByFilters()), 'Filtering'),
          1
      );
    },

    async updateByFilters(page) {
      page = this.clearObjects(this.filters, page)
      let response = await this.sendRequest(
          this.filtersUrl,
          this.filtersUrlMethod,
          page,
      );

      if (response) {
        this.checkAndSetRenderListFromResponse(response);
        this.$emit('set-filtered-list', response);
      }
    },
    async resetObject(object) {
      for (let prop in object) {
        if (Array.isArray(object[prop])) {
          object[prop] = [];
        } else {
          object[prop] = null;
        }
      }
      this.dateSelector = null;
    },

    async resetSelectingFilters() {
      this.$refs.childInstanceSelect.forEach(el => {
        el.clearFilteredData();
      })
      if (this.sendFilterRequestAfterSelect) {
        await this.updateByFiltersWithPause();
      }
    },
    checkAndSetRenderListFromResponse(response) {
      this.$refs?.childInstanceSelect?.forEach(el => {
        if (el.object.updateLabelFiltersAfterResponse !== undefined
            && typeof el.object.updateLabelFiltersAfterResponse === 'function') {
          let data = el.object.updateLabelFiltersAfterResponse(response);
          el.setDataRenderFiltersList(data);
        }
      })
    },
    async checkForSendRequestAfterSelectItemFilter() {
      if (this.sendFilterRequestAfterSelect) {
        (this.debounce(this.updateByFiltersWithPause, 800))();
      }
    },

    clearObjects(filters, page) {
      let data = {};
      if (this.perPage) {
        data.perPage = this.perPage;
      }
      if (typeof page !== 'undefined') {
        if (page?.perPage !== 'undefined') {
          data.perPage = page.perPage;
        }
        data.page = page.currentPage;
      }
      for (let filter in filters) {
        if (Array.isArray(filters[filter]) && filters[filter].length) {
          data[filter] = filters[filter];
        } else if (filters[filter] !== null) {
          data[filter] = filters[filter];
        }
      }
      return data;
    },
    async saveCsv() {
      this.timeout = setTimeout(
          () => this.doWithStopRequest(() => this.doWithLoader(() => this.downloadCsv()), 'Download CSV'),
          1
      );

    },
    async downloadCsv() {
      let response = await this.sendRequest(
          this.saveCsvUrl,
          'post',
          this.clearObjects(this.filters)
      );
      if (response && response !== ' ') {
        this.convertResponseToDownloadFileCsv(response);
      } else {
        await this.alertMessage(
            this.getLocalization('Error. Try again'),
            'error'
        );
      }
    },
    convertResponseToDownloadFileCsv(response) {
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');

      link.href = url;
      let date = new Date();
      let fileName = this.csvFilename + date.getHours() + '_' + date.getMinutes() + '.csv'
      link.setAttribute('download', fileName); // set custom file name
      document.body.appendChild(link);

      link.click();
      URL.revokeObjectURL(url);
      link.remove();
    },
    registerListeners() {
      if (this.$refs.inputFrom) {
        this.$refs.inputFrom.forEach(input =>this.addListenerForInput(input))
      }
      if (this.$refs.inputTo) {
        this.$refs.inputTo.forEach(input =>this.addListenerForInput(input))
      }
    },
    addListenerForInput(input) {
      input.addEventListener("touchstart", this.tapTouchHandler, false);
    },
    tapTouchHandler(event) {
      let type = "datetime-local";
      if (event.target.getAttribute('data-type')) {
        type = event.target.getAttribute('data-type');
      }
      if (event.target.type === type) {
        return;
      }
      event.target.type = type;
    },
    checkDefaultTime() {
      for (let filter in this.setEnabledFilters) {
        let obj = this.setEnabledFilters[filter];
        if (obj.defaultDateFrom) {
          this.filters.dateFrom = obj.defaultDateFrom;
        }
      }
    },
    showHint() {
      this.isHintVisible = true;
    },
    hideHint() {
      this.isHintVisible = false;
    },
    toggleHint() {
      this.isHintVisible = !this.isHintVisible;
    },
    handleInput (event, update) {
      if (event.inputType === 'deleteContentBackward') {
        return;
      }
      const input = event.target;
      let value = input.value.replace(/\D/g, '');


      if (value.length > 12) {
        value = value.slice(0, 12);
      }

      const formattedValue = this.formatDateTime(value);
      event.target.value = formattedValue;

      update(formattedValue);
    },
    formatDateTime(value) {
      const parts = [
        value.slice(0, 4),
        value.slice(4, 6),
        value.slice(6, 8),
        value.slice(8, 10),
        value.slice(10, 12)
      ];

      return parts
          .filter((part, index) => part.length > 0) // Исключаем пустые части
          .map((part, index) => {
            if (index === 0) return part; // Год без разделителя
            if (index < 3) return '-' + part; // Дата с "-"
            if (index === 3) return ' ' + part; // Разделитель между датой и временем
            return ':' + part; // Разделитель для времени
          })
          .join('');
    }
  },
  computed: {
    enabledFilters() {
      let data = {};
      for (let filter in this.setEnabledFilters) {
        let obj = this.setEnabledFilters[filter];
        let column = 1;
        if (obj.column && obj.column <= 3 && obj.column >= 1) {
          column = obj.column
        }
        if (!obj.placeholder) {
          obj.placeholder = '';
        }
        if (!obj.selectedKey) {
          obj.selectedKey = filter + 'Ids';
        }
        if (data[column] === undefined) {
          data[column] = {};
        }
        if (filter === 'date' || filter === 'dateWithOutTime') {
          obj.dateKey = ['dateFrom', 'dateTo'];
          if (obj.dateFiltersKey) {
            let from = obj.dateFiltersKey + 'From';
            let to = obj.dateFiltersKey + 'To'
            obj.dateKey = [from, to];

            this.filters[from] = null;
            this.filters[to] = null;
          }
        }
        data[column][filter] = obj;
      }
      return data;
    },
    showFiltersWithBtn() {
      if (this.setEnabledFilters
          && Object.keys(this.setEnabledFilters).length === 0
          && Object.getPrototypeOf(this.setEnabledFilters) === Object.prototype) {
        return true
      } else {
        return Object.keys(this.enabledFilters).length > 0;
      }
    },
    showSaveCsvBtn() {
      return this.enableSaveCsv && this.isListFiltered || this.alwaysShowCsvBtn;
    },
    isListFiltered: function () {
      for (let filter in this.filters) {
        if (Array.isArray(this.filters[filter]) && this.filters[filter].length) {
          return true;
        } else if (!Array.isArray(this.filters[filter]) && this.filters[filter]) {
          return true;
        }
      }
      return false;
    },
    getClass() {
      return {
        'hidden': !this.showFilters
      }
    }
  },
  watch: {
    'filters.dateTo'() {
      this.checkForSendRequestAfterSelectItemFilter();
    },
    'filters.dateFrom'() {
      this.checkForSendRequestAfterSelectItemFilter();
    },
  }

}
</script>

<style scoped>
.hidden {
  display: none;
}
input[type='datetime'] {
  background: #a62828;
  color: #000;
}
</style>
